import { render, staticRenderFns } from "./TopicsUpdateModal.vue?vue&type=template&id=716a30e6&"
import script from "./TopicsUpdateModal.vue?vue&type=script&lang=js&"
export * from "./TopicsUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports